import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import {LeaseDetails} from './leaseDetails';
import { FrenchTypes } from '../../../../../constants/utils/connectionTypes';

export const Tenant = ({ generateRelocationLetters }) => {
	const [tenantState, setTenantState] = useState({
		items: [],
	});

	const services = useSelector((state) => state.services);
	const user = useSelector((state) => state.user);

	const serviceData = R.isNil(services.serviceData[FrenchTypes.locataire]) ? [] : services.serviceData[FrenchTypes.locataire];
	useEffect(() => {
		let leaseInState = serviceData.filter((s) => s.serviceType === FrenchTypes.locataire);
		if (leaseInState.length > 0) {
			setTenantState({
				items: leaseInState,
			});
		} else {
			setTenantState({ ...tenantState, items: tenantState.items.concat({}) });
		}
	}, [services.serviceData]);

	function removeActivity(locataire) {
		setTenantState({ ...tenantState, items: tenantState.items.filter((a) => a !== locataire) });
	}

	return (
		<article className="block" id="activité">
			<h3 className="sr-only visually-hidden">Bail</h3>
			{tenantState.items.map((activity, index) => {
				return <LeaseDetails key={index} index={index} userId={user.user.id} activity={activity} removeActivity={removeActivity} generateRelocationLetters={generateRelocationLetters} />;
			})}

			<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
				<h4 className="sr-only visually-hidden">Ajouter un autre BAIL</h4>
				<button
					type="button"
					className="btn btn-icon btn-alert-info mx-auto py-2"
					onClick={(e) => {
						const nodes = window.document.querySelectorAll(".collapse.show");
						if (!R.isNil(nodes) && nodes.length > 0) {
							nodes.forEach((element) => {
								element.classList.remove(["show"]);
							});
						}
						setTenantState({
							...tenantState,
							items: tenantState.items.concat({
								type: "Locataire",
								name: "",
								addressStreet1: "",
								addressStreet2: "",
								addressPostalCode: "",
								addressLocality: "",
								addressCountry: "FR",
							}),
						});
					}}>
					<i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter un autre BAIL
				</button>
			</footer>
		</article>
	);
};